module.exports = "/_next/static/media/b3ec92573ca0db6954e35e0f8cc158db.svg";